import React from 'react'
 import './aemp.css'
const Wmpty = () => {
   return (
    <div className="contacts">
    <div className="wrap">
        <div className="container-top">
            <i className="fa fa-info"></i>
          <div className="text-center">
                <h6>Start Your Project Now</h6>
            </div>
            <h3 > <span className='light'> Get In Touch</span></h3>
              <div className='email'>
            <a href="mailto:nwakwueemmanuel1@gmail.com" className="button">Email Me </a>
         </div>
         </div>
       
    </div>
</div>
  )
}

export default Wmpty
